export { HandIcon } from './hand'
